import type {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'
import {AfterStatusIcon} from './effective-entry-status-icons/AfterStatusIcon'
import {ClosedStatusIcon} from './effective-entry-status-icons/ClosedStatusIcon'
import {DraftStatusIcon} from './effective-entry-status-icons/DraftStatusIcon'
import {LoadingStatusIcon} from './effective-entry-status-icons/LoadingStatusIcon'
import {MergedStatusIcon} from './effective-entry-status-icons/MergedStatusIcon'
import {MergingStatusIcon} from './effective-entry-status-icons/MergingStatusIcon'
import {NotReadyStatusIcon} from './effective-entry-status-icons/NotReadyStatusIcon'
import {QueuedStatusIcon} from './effective-entry-status-icons/QueuedStatusIcon'
import {ReadyStatusIcon} from './effective-entry-status-icons/ReadyStatusIcon'

export function EffectiveEntryStatusIcon(props: {status: EffectiveEntryStatus}) {
  return (
    <>
      <AfterStatusIcon {...props} />
      <ClosedStatusIcon {...props} />
      <DraftStatusIcon {...props} />
      <LoadingStatusIcon {...props} />
      <MergedStatusIcon {...props} />
      <MergingStatusIcon {...props} />
      <NotReadyStatusIcon {...props} />
      <QueuedStatusIcon {...props} />
      <ReadyStatusIcon {...props} />
    </>
  )
}
